:host {
  display: flex;
  width: 100%;
}

.float-div{
  padding: $size-space-md;
  display: flex;
  flex: 1;
  background-color: $color-base-brand-white;
  box-shadow: 0px 0px $size-space-md rgba(160, 160, 167, 0.25);
  z-index: 999;
  position: fixed;
  left: 0;
  right: 0;
  gap: $size-space-sm;
  justify-content: center;
}

.column {
  flex-direction: column;
}

.top {
  top: 0;
}

.bottom {
  bottom: 0;
}
